
/**
 * Simple Accordion class for the DDS Accordion component.
 */

const Cobalt = Cobalt || {};

(function($) {
  const instances = [];

  function init() {
    $('.accordion').each(function(){
      instances.push(new Accordion($(this)));
    });
  }

  const Accordion = function($el) {
    this.$el = $el;

    this.$items = this.$el.find('.accordion-item');
    this.items = this.$items.map(function() {
      return new AccordionItem($(this));
    });
  };


  const AccordionItem = function($el) {
    this.$el = $el;

    this.$header = this.$el.find('.accordion-header');
    this.$content = this.$el.find('.accordion-content');
    this.$toggle = this.$el.find('.accordion-toggle');

    this.$header.on('click', (this.headerClicked).bind(this));
  };

  AccordionItem.prototype.headerClicked = function(e) {
    e.preventDefault();
    this.setOpen(!this.$content.hasClass('is-open'));
  };

  AccordionItem.prototype.setOpen = function(open) {
    if (open) {
      this.$header.attr('aria-expanded', true);
      this.$content.addClass('is-open');
      this.$toggle.addClass('is-open');
    } else {
      this.$header.attr('aria-expanded', false);
      this.$content.removeClass('is-open');
      this.$toggle.removeClass('is-open');
    }
  };

  $(document).ready(init);

  Cobalt.Accordion = Accordion;
})(jQuery);